import { createEvent } from 'effector';

import { AuthState } from './AuthState';

export const authEvent = createEvent<Partial<AuthState>>('authEvent');
